
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fbHnC", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.f8651b36.js.map
